import { MainFilter } from 'components/tables/list-table/ListTableTypes';
import { t } from 'utils/getTranslations';
import { coreTeamFilter, employeeFilter, isActiveFilter, jobRoleFilter, singleChoiceFilter } from '../reportFilters';
import { monthNames } from './chartFormat';

/**
 * Filter-bar pieces of the trend reports. The selectors are the trend report API's contract: each filters the
 * report's rows, and the employee ones read the job role and core team of the employment valid today.
 */

export const YEAR_SELECTOR = 'year';

/** The years a trend report covers: the current year and the three before it, newest first. */
export function reportYears(today: Date): number[] {
    return [0, 1, 2, 3].map((back) => today.getFullYear() - back);
}

export function yearFilter(today: Date): MainFilter {
    return singleChoiceFilter(
        YEAR_SELECTOR,
        'reporting.filter.year',
        reportYears(today).map((year) => ({ label: `${year}`, value: year }))
    );
}

/** The months of the chosen years, by number. */
export function monthFilter(): MainFilter {
    return {
        type: 'multiselect',
        label: t('reporting.filter.month'),
        selector: 'month',
        options: monthNames().map((name, index) => ({ label: name, value: index + 1 })),
    };
}

/** The filters every employee trend report has, after its period filters. */
export function employeeTrendFilters(): MainFilter[] {
    return [
        jobRoleFilter(),
        employeeFilter('employeeId', 'reporting.filter.employee'),
        isActiveFilter(),
        coreTeamFilter(),
    ];
}

/** The search box of an employee trend report: it matches the employee's name. */
export const EMPLOYEE_NAME_SEARCH = [{ selector: 'employeeName', comparator: '=lk=' }];

/** The list's starting URL state: the current year, as the report's year filter defaults to the newest year. */
export function currentYearSearchParams(today: Date): string {
    return new URLSearchParams({ qf: `${YEAR_SELECTOR}==${today.getFullYear()}` }).toString();
}
